import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PopupLink from '../../../shared-components/PopupLink/PopupLink';
import _ from 'lodash';
import './TermsText.less';
import { TERMS_POPUP_WIDTH } from '../../USConstants';
import { getContent } from 'pp-react-l10n';

export class TermsText extends Component {

    static propTypes = {
        name: PropTypes.string,
        termsText: PropTypes.string,
        termsUrl: PropTypes.string,
        termsLinkText: PropTypes.string
    };

    render() {
        const { name, termsUrl, termsText, termsLinkText } = this.props;

        const showPopupConfig = {
            width: TERMS_POPUP_WIDTH
        };

        const getTermsContent = getContent({
            content: {
                termsText,
                termsLinkText
            },
            useHTML: true
        });

        return (
            <p className="TermsText tertiary">
                {getTermsContent('termsText')}
                &nbsp;
                <PopupLink url={termsUrl} name={name} showPopupConfig={showPopupConfig}>
                    {getTermsContent('termsLinkText')}
                </PopupLink>
            </p>
        );
    }
}

export default TermsText;
